import { __rest, __assign } from 'tslib';
import React__default, { Suspense, useCallback } from 'react';
import { SelectAllStatus, activeBusinessFiltersState, useTotalCount, useSelectAllInAdvancedSearch } from '@keepeek/commons';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ElementCount from '../../ElementCount/index.js';
import { withSuspense } from '../../withSuspense/index.js';

var TotalCountWithSuspense = function (_a) {
    var allowSelection = _a.allowSelection, KIcon = _a.KIcon, props = __rest(_a, ["allowSelection", "KIcon"]);
    return (React__default.createElement(Suspense, { fallback: React__default.createElement(ElementCount, { selectStatus: SelectAllStatus.NONE, selectLoading: true, mediasCount: 0, loading: true, allowSelection: allowSelection, KIcon: KIcon }) },
        React__default.createElement(TotalCount, __assign({ allowSelection: allowSelection }, props, { KIcon: KIcon }))));
};
var TotalCount = function (_a) {
    var sentryCallback = _a.sentryCallback, dataViewKey = _a.dataViewKey, allowSelection = _a.allowSelection, EditableSanitizeHtml = _a.EditableSanitizeHtml, KIcon = _a.KIcon;
    var t = useTranslation("refront-components").t;
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var filters = useRecoilValue(activeBusinessFiltersState(dataViewKey)) || null;
    var totalCount = useTotalCount({
        key: dataViewKey,
        filters: filters
    });
    var _b = useSelectAllInAdvancedSearch({
        key: dataViewKey,
        filters: filters,
        totalCount: totalCount,
        tooManyMediaSelectedCallback: useCallback(function (maxSelectAll) {
            return enqueueSnackbar(t("components.dataview.select-all.too-much.notification", { count: maxSelectAll }), {
                variant: "info"
            });
        }, [enqueueSnackbar, t]),
        sentryCallback: sentryCallback
    }), toggleSelectAll = _b.toggleSelectAll, status = _b.status;
    return (React__default.createElement(ElementCount, { onSelect: toggleSelectAll, selectStatus: status, selectLoading: false, mediasCount: totalCount, loading: false, EditableSanitizeHtml: EditableSanitizeHtml, allowSelection: allowSelection, KIcon: KIcon }));
};
var TotalCount$1 = withSuspense(TotalCountWithSuspense);

export { TotalCount$1 as default };
//# sourceMappingURL=index.js.map
